import React from "react";

function ReportsIllustration() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 400 200"
      style={{ width: "100%", height: "auto" }}
      preserveAspectRatio="xMidYMid meet"
    >
      {/* Background circle decoration */}
      <circle cx="60" cy="40" r="30" fill="#E8F5E9" opacity="0.6" />
      <circle cx="360" cy="160" r="25" fill="#C8E6D7" opacity="0.5" />

      {/* Chart icon (top left) */}
      <g transform="translate(40, 25)">
        <rect x="0" y="0" width="40" height="40" rx="6" fill="#5F9F7F" opacity="0.2" />
        <rect x="8" y="24" width="6" height="10" rx="1" fill="#5F9F7F" />
        <rect x="16" y="18" width="6" height="16" rx="1" fill="#5F9F7F" />
        <rect x="24" y="20" width="6" height="14" rx="1" fill="#5F9F7F" />
      </g>

      {/* Person (simplified, left side) */}
      <g transform="translate(45, 85)">
        {/* Head */}
        <circle cx="20" cy="12" r="10" fill="#DEB8A0" />

        {/* Hair/ponytail */}
        <ellipse cx="15" cy="8" rx="12" ry="14" fill="#5A7C6B" />
        <ellipse cx="5" cy="12" rx="7" ry="10" fill="#5A7C6B" />

        {/* Body */}
        <rect x="12" y="22" width="16" height="30" rx="8" fill="#5F9F7F" />

        {/* Left arm */}
        <rect x="4" y="26" width="8" height="22" rx="4" fill="#5F9F7F" transform="rotate(-5 8 37)" />

        {/* Right arm (holding tablet) */}
        <rect x="28" y="28" width="8" height="20" rx="4" fill="#5F9F7F" transform="rotate(20 32 38)" />

        {/* Tablet in hand */}
        <rect x="38" y="32" width="16" height="22" rx="2" fill="#7FB09F" />
        <rect x="40" y="34" width="12" height="16" rx="1" fill="#B8D9CA" />

        {/* Legs */}
        <rect x="14" y="50" width="6" height="30" rx="3" fill="#3D6B5A" />
        <rect x="20" y="50" width="6" height="30" rx="3" fill="#3D6B5A" />

        {/* Feet */}
        <ellipse cx="17" cy="82" rx="5" ry="3" fill="#2C4A3E" />
        <ellipse cx="23" cy="82" rx="5" ry="3" fill="#2C4A3E" />
      </g>

      {/* Computer/Screen (center) */}
      <g transform="translate(150, 55)">
        {/* Monitor stand */}
        <rect x="45" y="110" width="5" height="15" fill="#546E7A" />
        <rect x="35" y="125" width="25" height="3" rx="1.5" fill="#455A64" />

        {/* Screen outer */}
        <rect x="0" y="0" width="95" height="115" rx="5" fill="#5F9F7F" />
        {/* Screen inner */}
        <rect x="5" y="5" width="85" height="105" rx="3" fill="white" />

        {/* Browser top bar */}
        <rect x="8" y="8" width="79" height="12" rx="2" fill="#7FB09F" />
        <circle cx="13" cy="14" r="2" fill="white" opacity="0.7" />
        <circle cx="19" cy="14" r="2" fill="white" opacity="0.7" />
        <circle cx="25" cy="14" r="2" fill="white" opacity="0.7" />

        {/* Content area - table representation */}
        <rect x="12" y="25" width="25" height="18" rx="2" fill="#C8E6D7" />
        <rect x="40" y="25" width="16" height="6" rx="1" fill="#E0E0E0" />
        <rect x="59" y="25" width="16" height="6" rx="1" fill="#E0E0E0" />
        <rect x="40" y="34" width="35" height="6" rx="1" fill="#E0E0E0" />

        <rect x="12" y="48" width="18" height="6" rx="1" fill="#E0E0E0" />
        <rect x="33" y="48" width="14" height="6" rx="1" fill="#E0E0E0" />
        <rect x="50" y="48" width="25" height="6" rx="1" fill="#E0E0E0" />

        <rect x="12" y="58" width="18" height="6" rx="1" fill="#E0E0E0" />
        <rect x="33" y="58" width="14" height="6" rx="1" fill="#E0E0E0" />
        <rect x="50" y="58" width="25" height="6" rx="1" fill="#E0E0E0" />

        <rect x="12" y="68" width="18" height="6" rx="1" fill="#E0E0E0" />
        <rect x="33" y="68" width="14" height="6" rx="1" fill="#E0E0E0" />
        <rect x="50" y="68" width="25" height="6" rx="1" fill="#E0E0E0" />
      </g>

      {/* Arrow from computer to files */}
      <path
        d="M 245 90 L 280 60"
        stroke="#5F9F7F"
        strokeWidth="3"
        fill="none"
        strokeLinecap="round"
        markerEnd="url(#arrow)"
      />
      <path
        d="M 245 110 L 280 140"
        stroke="#5F9F7F"
        strokeWidth="3"
        fill="none"
        strokeLinecap="round"
        markerEnd="url(#arrow)"
      />

      {/* CSV File (top right) */}
      <g transform="translate(285, 30)">
        <rect x="0" y="0" width="45" height="58" rx="3" fill="white" stroke="#5F9F7F" strokeWidth="2" />
        <path d="M 45 0 L 45 15 L 60 15 L 45 0" fill="#B8D9CA" stroke="#5F9F7F" strokeWidth="2" />
        <text x="22.5" y="38" fontSize="16" fontWeight="bold" fill="#5F9F7F" textAnchor="middle">CSV</text>
      </g>

      {/* XLS File (bottom right) */}
      <g transform="translate(285, 115)">
        <rect x="0" y="0" width="45" height="58" rx="3" fill="white" stroke="#5F9F7F" strokeWidth="2" />
        <path d="M 45 0 L 45 15 L 60 15 L 45 0" fill="#B8D9CA" stroke="#5F9F7F" strokeWidth="2" />
        <text x="22.5" y="38" fontSize="16" fontWeight="bold" fill="#5F9F7F" textAnchor="middle">XLS</text>
      </g>

      {/* Arrow marker definition */}
      <defs>
        <marker
          id="arrow"
          markerWidth="10"
          markerHeight="10"
          refX="9"
          refY="3"
          orient="auto"
          markerUnits="strokeWidth"
        >
          <path d="M0,0 L0,6 L9,3 z" fill="#5F9F7F" />
        </marker>
      </defs>
    </svg>
  );
}

export default ReportsIllustration;
